import * as _ from 'lodash';

import { store } from '../App';

/* According to ServerValues */
const Rules = {
  ADMIN: 'admin',
  MANAGER: 'manager',
  OPERATOR: 'operator',
  NONE: '',
};

const Actions = {
  CREATE: 'CREATE',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
};

const Entities = {
  ALL: 'ALL',
  DRIVER: 'DRIVER',
  DRIVERS: 'DRIVERS',
};

function can(action/* , entity */) {
  const rule = _.get(store.getState(), 'authState.currentUser.rule', Rules.NONE);

  switch (rule) {
    case Rules.ADMIN: return true;
    case Rules.MANAGER:
      switch (action) {
        case Actions.UPDATE: return true;
        default: return false;
      }
    default: return false;
  }
}

function cannot(...args) {
  return !can(...args);
}

export default {
  Rules,
  Actions,
  Entities,
  can,
  cannot,
};



// WEBPACK FOOTER //
// ./src/Api/Authorization.js